import { useState } from 'react';
import PropTypes from 'prop-types';
import SocialShare from '../SocialMediaShare';
import Styles from './SharePost.module.scss';
import IconCopy from '@hiredigital/ui/Icon/icons/copy-file.inline.svg';

const SharePost = ({ className, postUrl, postTitle, ...props }) => {
  const [actionTimeout, setActionTimeout] = useState();

  const onCopyLink = async (event) => {
    try {
      const targetClasses = event?.currentTarget?.classList;
      if (targetClasses) {
        targetClasses.add(Styles.actioned);
        clearTimeout(actionTimeout);
        setActionTimeout(setTimeout(() => targetClasses.remove(Styles.actioned), 1500));
      }
      await navigator.clipboard.writeText(window.location.href);
    } catch (err) {
      console.error('Fail to copy url!', err);
    }
  };

  return (
    <div className={Styles.container} style={{ ...props?.style }}>
      <button onClick={onCopyLink} className={Styles.actionShare}>{`Share this post`}</button>
      <SocialShare
        postUrl={postUrl}
        postTitle={postTitle}
        style={{ width: 'auto', flex: 1, diplay: 'flex', justifyContent: 'flex-end' }}>
        <button onClick={onCopyLink} className={Styles.actionCopy}>
          <IconCopy />
          {`Copy link`}
        </button>
      </SocialShare>
    </div>
  );
};

SharePost.propTypes = {
  postUrl: PropTypes.string,
  postTitle: PropTypes.string,
};

export default SharePost;
